import { createContext, useContext, useState } from 'react';

const ScheduleChangeHostContext = createContext();

const initialState = {
  scheduleChangeHostData: [],
  rowErrors: {},
};

const ScheduleChangeHostProvider = ({ children }) => {
  const [state, setState] = useState(initialState);

  const updateState = (payload) =>
    setState((prev) => ({ ...prev, ...(typeof payload === 'function' ? payload(prev) : payload) }));
  const resetState = () => setState(initialState);

  return <ScheduleChangeHostContext.Provider value={{ updateState, resetState, ...state }}>{children}</ScheduleChangeHostContext.Provider>;
};

export const useScheduleChangeHostState = () => {
  return useContext(ScheduleChangeHostContext);
};

export default ScheduleChangeHostProvider;
